var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountDefaultIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2757_26889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55188 0.599609V2.34961H8.80188V3.90039H7.89661L7.88293 3.9834C7.64439 5.42619 7.01498 6.72287 6.11731 7.74121L6.03333 7.83691L6.14563 7.89551C6.80852 8.24197 7.54819 8.44717 8.32922 8.47266L8.4054 8.47461L8.42786 8.40137L9.19836 5.84961H11.0421L13.6222 14.4004H12.1232L11.6163 12.7207L11.5948 12.6504H8.64563L8.62415 12.7207L8.11731 14.4004H6.61829L7.91028 10.1182L7.94446 10.0029L7.82434 9.99023C6.75647 9.87763 5.76054 9.49811 4.89465 8.91504L4.83899 8.87793L4.78333 8.91504C3.73861 9.61847 2.5045 10.0254 1.18274 10.0254H0.876099V8.47461H1.18274C2.02505 8.47461 2.82259 8.26646 3.53235 7.89551L3.64465 7.83691L3.56067 7.74121C3.0716 7.18639 2.6637 6.54822 2.35364 5.84961H3.98938C4.21308 6.21761 4.47301 6.55776 4.76672 6.86133L4.83899 6.93555L4.91125 6.86133C5.64523 6.10274 6.17855 5.12238 6.42004 4.02148L6.44739 3.90039H0.876099V2.34961H4.1261V0.599609H5.55188ZM10.0245 8.08105L9.15247 10.9707L9.1134 11.0996H11.1271L11.088 10.9707L10.2159 8.08105L10.1202 7.76367L10.0245 8.08105Z",
    fill: "black",
    stroke: "#F6F6F6",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2757_26889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white",
    transform: "translate(0.776489 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDefaultIcon);
export default __webpack_public_path__ + "static/media/AccountDefaultIcon.fdc0d9da2b2dd73eee85af57f5d7bd04.svg";
export { ForwardRef as ReactComponent };